import React, { cloneElement, Fragment } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PROP from "../../../../constant/PROP";
import useLocalStorage from "../../../../hooks/useLocalStorage";

const Closer = ( props ) => {

  const history = useHistory();
  const location = useLocation();

  const { setUserData } = useLocalStorage();

  const close = () => {
    const {
      nextUrl,
      ...state
    } = location.state || {};
    setUserData( { [ `isTutorial.${ PROP.ANSWERING_QUESTIONS_TUTORIAL_VERSION }` ] : true } );
    history.replace( {
      pathname : nextUrl,
      state : state
    } );
  };

  return cloneElement( props.children || <Fragment />, {
    onClick : close
  } );

};

export default Closer;
